/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Select, message, Modal, DatePicker, Form } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import ContituentSelect from '../../../components/Custom/ConstituentSelect'
import ConstituentDetails from '../details'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			selectedConstituent: null,
			didSelectConstituent: false,
			selectedOfficer: null,
			didSelectOfficer: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { selectedConstituent } = this.state
		const { form, AuthStore, saveCertificate, onClose } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			const request_date = moment(values.request_date).format('YYYY-MM-DD HH:mm:ss')
			const ctc_date = moment(values.ctc_date).format('YYYY-MM-DD HH:mm:ss')
			const or_issued_date = moment(values.or_issued_date).format('YYYY-MM-DD HH:mm:ss')
			let params = Object.assign({}, values, {
				barangay_uid,
				name: (!selectedConstituent.didSelectConstituent) ? selectedConstituent.name : `${selectedConstituent.first_name} ${selectedConstituent.middle_name || ''} ${selectedConstituent.last_name}`,
				constituent_uid: selectedConstituent.uid,
				request_date, ctc_date, or_issued_date
			})
			// console.log('params', params)

			message.loading({ key: 'set_certificate', content: 'Generating Certificate, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveCertificate(params).then((response) => {
					const { file_url } = response.data.setCertificateBarangayClearance
					window.open(`${process.env.REACT_APP_BACKEND_API}${file_url}`, '_blank')
					this.setState({ isSaving: false })
					message.success({ key: 'set_certificate', content: 'Certificate successfully generated.' })

					//create audit trail
					const auditParams = {
						module_name: 'Clearance',
						action: 'Create',
						message: 'Generate Barangay Clearance'
					}
					AuthStore.saveAuditTrail(auditParams)

					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error generating certificate')
					message.error({ key: 'set_certificate', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, AuthStore } = this.props
		const { getFieldDecorator, getFieldValue } = form
		const { barangay_uid, or_required } = AuthStore
		const { selectedConstituent, isSaving } = this.state
		
		return (
			<Modal
				title="Certificate of Barangay Clearance"
				// placement="right"
				// closable={!isSaving}
				// onClose={onClose}
				visible={visible}
				width={'70%'}
				// bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
				okText='Generate'
				maskClosable={!isSaving}
				onCancel={onClose}
				onOk={this.handleSubmit}
				confirmLoading={isSaving}
			>
				<Form onSubmit={this.handleSubmit}>
					{
						selectedConstituent &&
						<ConstituentDetails selectedConstituent={selectedConstituent} table_name='certificate_barangay_clearance' />
					}
					<Row gutter={16}>
						<Col md={18} sm={24}>
							<Form.Item label='Constituent'>
								{ getFieldDecorator('constituent_uid', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<ContituentSelect 
										barangay_uid={barangay_uid}
										placeholder='Select Constituent Name'
										onSelectedItem={(item) => {
											if (item) {
												this.setState({ selectedConstituent: Object.assign({}, item, { didSelectConstituent: true }) })
											} else {
												this.setState({ selectedConstituent: null })
											}
										}}
									/>
								)}
							</Form.Item>
						</Col>
						<Col md={6} sm={24}>
							<Form.Item label='Request Date'>
								{ getFieldDecorator('request_date', {
									initialValue: moment(new Date()),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker format='LL' style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='O.R. Number'>
								{ getFieldDecorator('or_number', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter OR Number' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='O.R. Amount'>
								{ getFieldDecorator('amount', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input type='number' min={0} placeholder='Enter Amount' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='O.R. Issued Date'>
								{ getFieldDecorator('or_issued_date', {
									initialValue: moment(new Date()),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker format='LL' style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='CTC No.'>
								{ getFieldDecorator('ctc_no', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter CTC number' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='CTC Amount'>
								{ getFieldDecorator('ctc_amount', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input type='number' min={0} placeholder='Enter Amount' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='CTC Date'>
								{ getFieldDecorator('ctc_date', {
									initialValue: moment(new Date()),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker format='LL' style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='CTC Issued At'>
								{ getFieldDecorator('issued_at', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter issued at' />
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Select Purpose'>
								{ getFieldDecorator('purpose', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Purpose Type'>
										<Select.Option value='Enrollment/School Requirement'>Enrollment/School Requirement</Select.Option>
										<Select.Option value='Pre-Employment'>Pre-Employment</Select.Option>
										<Select.Option value='Postal ID'>Postal ID</Select.Option>
										<Select.Option value='Police Clearance'>Police Clearance</Select.Option>
										<Select.Option value='Loan Purpose'>Loan Purpose</Select.Option>
										<Select.Option value='Others (Specify)'>Others (Specify)</Select.Option>
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							(getFieldValue('purpose') && _.isEqual(getFieldValue('purpose'), 'Others (Specify)')) &&
							<Col md={12} sm={24}>
								<Form.Item label='Specify other purpose'>
									{ getFieldDecorator('others_specify', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}]
									})
									(
										<Input.TextArea rows={4} placeholder='Enter other purpose' />
									)}
								</Form.Item>
							</Col>
						}
					</Row>
					{/* <Row>
						<Form.Item label='Name of Child'>
							{ getFieldDecorator('purpose', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter name of child' />
							)}
						</Form.Item>
					</Row> */}
					
				</Form>
				{/* <div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button disabled={isSaving} type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div> */}
			</Modal>
		)
	}
}

const GENERATE_CERTIFICATE = gql`
    mutation setCertificateBarangayClearance($input: JSON) {
		setCertificateBarangayClearance(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-generate-certificate' }),
	inject('AuthStore'),
	graphql(GENERATE_CERTIFICATE, {
		props({ mutate }) {
			return {
				saveCertificate(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allBarangayClearance']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
